import { render, staticRenderFns } from "./AddChildren.vue?vue&type=template&id=5cdead2e&scoped=true"
import script from "./AddChildren.vue?vue&type=script&lang=js"
export * from "./AddChildren.vue?vue&type=script&lang=js"
import style0 from "./AddChildren.vue?vue&type=style&index=0&id=5cdead2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdead2e",
  null
  
)

export default component.exports